import React, {memo, Suspense} from 'react';
import config from './service/config';
import './static/css/index-header.less';
import HeaderPlaceholder from './component/header/HeaderPlaceholder';
import Header from './component/header/Header';
import Sidebar from './component/sidebar/Sidebar';
import {ContentArea, PageWrapper, SidebarContainer} from './component/util/StyledElements';
import {BrowserRouter} from 'react-router-dom';
import StateProvider, {PWCEntryPoint} from './context/stateProvider';
import {generateFeedTabs} from './util/NavLinkTabsGenerator';
import ScreenReaderHelper from './component/util/ScreenReaderHelper';
import {useTranslation} from 'react-i18next';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {QueryParamProvider} from 'use-query-params';
import {ILibraryModel} from './model/appModel';
import Feed from './component/feed/Feed';
import {ReactRouter5Adapter} from 'use-query-params/adapters/react-router-5';
import {useTscTheme} from './context/themeProvider';
import {createRoot} from 'react-dom/client';

const FeedBase: React.FC = () => {
   const {t} = useTranslation();
   const theme = useTscTheme();

   return (
      <DndProvider backend={HTML5Backend}>
         <QueryParamProvider adapter={ReactRouter5Adapter}>
            <PageWrapper
               id="modal-root"
               theme={theme}
            >
               <ScreenReaderHelper
                  href="#start-of-content"
                  text={t('accessibility.skipLinkText')}
               />
               <Suspense fallback={<HeaderPlaceholder />}>
                  <Header
                     hideSearch={true}
                     hideEntitlementInfo={false}
                     hideThemePicker={false}
                     hideNavLinkTabs={config.featureSwitches.IsScreencast}
                  />
               </Suspense>
               <ContentArea>
                  {config.feedConfig.showSidebar && (
                     <SidebarContainer>
                        <Sidebar
                           menuIsHidden={false}
                           tabs={generateFeedTabs()}
                           displayAddMediaContent={config.sidebarShowCreate}
                        />
                     </SidebarContainer>
                  )}
                  <Feed contentSectionId="start-of-content" />
               </ContentArea>
            </PageWrapper>
         </QueryParamProvider>
      </DndProvider>
   );
};

const FeedComponent = memo(FeedBase);

export default (model: ILibraryModel) => {
   const feedRoot = document.getElementById('feed-root');
   if (!feedRoot) {
      return;
   }

   document.body.classList.add('app-body');

   config.initFeed(model);

   createRoot(feedRoot).render(
      <BrowserRouter>
         <StateProvider entryPoint={PWCEntryPoint.Collections}>
            <FeedComponent />
         </StateProvider>
      </BrowserRouter>
   );
};
